import { render, staticRenderFns } from "./BlockWalletModal.vue?vue&type=template&id=082f735c&scoped=true&"
import script from "./BlockWalletModal.vue?vue&type=script&lang=js&"
export * from "./BlockWalletModal.vue?vue&type=script&lang=js&"
import style0 from "./BlockWalletModal.vue?vue&type=style&index=0&id=082f735c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082f735c",
  null
  
)

export default component.exports